var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.95 18.35 7.4 14.8l1.45-1.45 2.1 2.1 4.2-4.2 1.45 1.45ZM5 22q-.825 0-1.413-.587Q3 20.825 3 20V6q0-.825.587-1.412Q4.175 4 5 4h1V2h2v2h8V2h2v2h1q.825 0 1.413.588Q21 5.175 21 6v14q0 .825-.587 1.413Q19.825 22 19 22Zm0-2h14V10H5v10ZM5 8h14V6H5Zm0 0V6v2Z"}));
}

Calendar.defaultProps = {"height":"24","width":"24"};

module.exports = Calendar;

Calendar.default = Calendar;
